var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "../fields/Select";
export var SelectWidget = function (_a) {
    var options = _a.options, onChange = _a.onChange, rawErrors = _a.rawErrors, props = __rest(_a, ["options", "onChange", "rawErrors"]);
    var error = rawErrors === null || rawErrors === void 0 ? void 0 : rawErrors[0];
    var enumOptions = options.enumOptions;
    var handleChange = function (option) {
        onChange(option.value);
    };
    return (_jsx(Select, __assign({ options: enumOptions, error: error, onChange: handleChange }, props)));
};
